import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Page } from 'components/layouts';
import HeaderSimple from 'components/header-simple';
import Spinner from 'components/spinner';
import Alert from 'components/alert';
import FullPageLoading from 'components/full-page-loading';

import { useAuth } from 'context/auth';

import './style.css';

const ConfirmEmailValidate = () => {
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const { confirmEmail } = useAuth();
  const { token } = useParams();
  const history = useHistory();

  useEffect(() => {
    const validate = async () => {
      setLoading(true);
      try {
        await confirmEmail({ token });
        setLoading(false);
        history.push('/');
        toast.success('Email confirmed');
      } catch (e) {
        setLoading(false);
        setError(e);
        console.error(e);
      }
    };
    validate();
  }, [confirmEmail, history, token]);

  if (loading === 'loading')
    return <FullPageLoading header={false} footer={false} />;

  return (
    <Page
      className="page -confirm-email-validate"
      header={false}
      footer={false}
      theme="white"
    >
      <HeaderSimple />
      {error ? (
        <section className="confirm-email-errors">
          <Alert type="error" message="Something went wrong">
            <p>Try asking for new confirmation email</p>
          </Alert>
        </section>
      ) : (
        <section className="confirm-email-loading">
          <Spinner />
        </section>
      )}
    </Page>
  );
};

export default ConfirmEmailValidate;
